import { FertilizerPlan, FertilizerPlanOut, FertilizerPlanCrop, FertilizerPlanDictionaries, FertilizerPlanPlot } from '../models/FertilizerPlan';
import { PagingParams, PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import axios, { CancelTokenSource } from "axios";

export default class FertilizerPlanApi {

    private http: HTTPClient;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient){
        this.http = http;
        this.cancelTokenSource = null;
    }

    public async getFertilizerPlanDictionaries(): Promise<FertilizerPlanDictionaries>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots_plus/fertilizer_plan/dictionary`)
        return res.data;
    }

    public async getFertilizerPlan(pkCuaa: number, campaign: number, fp_header_id: number): Promise<FertilizerPlan>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots_plus/subjects/${pkCuaa}/campaigns/${campaign}/fertilizer_plans/${fp_header_id}`);
        return res.data;
    }
    public async getFertilizerPlans(pkCuaa: number, campaign: number, search?: string | null): Promise<FertilizerPlan[]>{
        const filter = [];
        if(search && search != ""){
            search = search.toUpperCase();
            filter.push(`^description like ${search}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots_plus/subjects/${pkCuaa}/campaigns/${campaign}/fertilizer_plans`, {
            params: {
                filter: filter.length ? filter : undefined,
            },
        })
        return res.data;
    }
    public async getFertilizerPlanPlots(pkid: number, paging: PagingParams, search?: string | null): Promise<PagedResults<FertilizerPlanCrop>>{
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel();
        }
        this.cancelTokenSource = axios.CancelToken.source();
        const filter = [];
        if(search && search != ""){
            search = search.toUpperCase();
            filter.push(`^crop_label like ${search}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_crop_filters/${pkid}/crops`, {
            params: {
                filter: filter.length ? filter : undefined,
                offset: paging.offset,
                count: paging.count
            },
            cancelToken: this.cancelTokenSource?.token
        })
        return res.data;
    }
    public async getFertilizerPlanCropByCode(pkid: number, code: string): Promise<PagedResults<FertilizerPlanCrop>>{
        const filter = [];
        filter.push(`crop_code eq ${code}`);
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_crop_filters/${pkid}/crops`, {
            params: {
                filter: filter.length ? filter : undefined,
                offset: 0,
                count: 1
            },
        })
        return res.data;
    }
    public async insertFertilizerPlan(pkCuaa: number, campaign: number, detailOut: FertilizerPlanOut): Promise<FertilizerPlan> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/plots_plus/subjects/${pkCuaa}/campaigns/${campaign}/fertilizer_plans`, detailOut);
        return res.data;
    }
    public async deleteFertilizerPlan(pkCuaa: number, campaign: number, fp_header_id: number): Promise<FertilizerPlan> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots_plus/subjects/${pkCuaa}/campaigns/${campaign}/fertilizer_plans/${fp_header_id}`);
        return res.data;
    }
    public async updateFertilizerPlan(pkCuaa: number, campaign: number, fp_header_id: number, detailOut: FertilizerPlanOut): Promise<FertilizerPlan> {
        // remove field fert_crop_code from detailOut
        delete detailOut.fert_crop_code;
        const res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/plots_plus/subjects/${pkCuaa}/campaigns/${campaign}/fertilizer_plans/${fp_header_id}`, detailOut);
        return res.data;
    }

    public async insertFertilizerPlanPlot(fp_header_id: number, plot_id: number): Promise<FertilizerPlanPlot> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/plots_plus/fertilizer_plans/${fp_header_id}/plots/${plot_id}`, {});
        return res.data;
    }
    public async deleteFertilizerPlanPlot(fp_header_id: number, plot_id: number): Promise<FertilizerPlanPlot> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots_plus/fertilizer_plans/${fp_header_id}/plots/${plot_id}`);
        return res.data;
    }

    public async getCurrentCampaign(): Promise<number> {
        const res = await this.http.get("/sitiagri-rest-api/api_basic/v1/land_uses/current_campaign");
        return res.data.campaign
    }

}
